import Token from './Token';

abstract class ValueToken<T> implements Token {

	public constructor (private value: T) {}

	public getValue () {
		return this.value;
	}
}

export default ValueToken;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/tokens/ValueToken.ts